(() => {
  const players = new Map();
  function mount(root) {
    root.querySelectorAll('[data-drop-film]').forEach(frame => {
      if (players.has(frame)) return;
      const video = frame.querySelector('video');
      const button = frame.querySelector('[data-film-toggle]');
      if (!video || !button) return;
      const label = button.querySelector('[data-film-button-label]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let userStarted = false;
      let visible = false;
      let failed = false;
      let destroyed = false;
      const canPlay = () => !destroyed && !failed && visible && !document.hidden && !userPaused && (!motion.matches || userStarted);
      const update = () => {
        const playing = !video.paused && !video.ended;
        frame.toggleAttribute('data-film-playing', playing);
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        label.textContent = playing ? button.dataset.pauseShort : button.dataset.playShort;
      };
      const sync = () => {
        if (canPlay()) {
          video.play().then(() => {
            if (!canPlay()) video.pause();
          }).catch(() => update());
        } else video.pause();
      };
      const onPlaying = () => { frame.setAttribute('data-film-ready', ''); update(); };
      const onError = () => { failed = true; frame.removeAttribute('data-film-ready'); button.hidden = true; };
      const onToggle = () => {
        if (video.paused) { userPaused = false; userStarted = true; }
        else { userPaused = true; }
        sync();
      };
      const onMotion = () => { userStarted = false; sync(); if (motion.matches) frame.removeAttribute('data-film-ready'); };
      video.muted = true;
      video.playsInline = true;
      button.hidden = false;
      video.addEventListener('playing', onPlaying);
      video.addEventListener('pause', update);
      video.addEventListener('error', onError);
      button.addEventListener('click', onToggle);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', onMotion);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0 });
      observer.observe(frame);
      players.set(frame, () => {
        destroyed = true;
        observer.disconnect();
        document.removeEventListener('visibilitychange', sync);
        motion.removeEventListener('change', onMotion);
        video.removeEventListener('playing', onPlaying);
        video.removeEventListener('pause', update);
        video.removeEventListener('error', onError);
        button.removeEventListener('click', onToggle);
        video.pause();
        players.delete(frame);
      });
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    players.forEach((destroy, frame) => { if (event.target.contains(frame)) destroy(); });
  });
})();
